import _ from "lodash";
import {
  MarketplaceProposalTemplate,
  MarketplaceProposalTemplateItemType,
  ProposalMetaItem,
  MarketplaceProposalDetails,
  MarketplaceProposalPhase,
  MarketplaceAnonOpportunityInput,
} from "../../../schema/generated/schema";
import { FormInstance } from "../ProposalForm/types";

export type MetaFormMap = {
  [key: string]: FormInstance;
};

export type OverviewFormData = MarketplaceProposalDetails & {
  subject: string;
};

export type AnonOpportunityFormData = MarketplaceAnonOpportunityInput;

export const getMetaFormMap = (
  proposalTemplate: MarketplaceProposalTemplate,
  metaItems: ProposalMetaItem[],
  phase: MarketplaceProposalPhase
): MetaFormMap => {
  const nextFormInfo = {};
  const isFormHidden = proposalTemplate.items.reduce((memo, item) => {
    if (item.hideWhen && item.hideWhen.includes(phase)) {
      // eslint-disable-next-line no-param-reassign
      memo[item.formId] = true;
    }
    return memo;
  }, {});
  proposalTemplate?.items
    ?.filter(
      item =>
        item.type === MarketplaceProposalTemplateItemType.MetaData &&
        !isFormHidden[item.formId]
    )
    .forEach(item => {
      const { formVersion } = item;
      const existingItem = _.find(metaItems, proposalMetaItem => {
        const formId = proposalMetaItem?.formVersion?.id;
        return formId && formId === formVersion.id;
      }) as ProposalMetaItem | undefined;
      const form = existingItem?.formVersion || formVersion;
      const key = form.versionId;
      let formData = {};
      if (existingItem?.formData) {
        formData = _.cloneDeep(existingItem.formData);
      }
      nextFormInfo[key] = {
        key,
        touchAllErrors: false,
        dirty: false,
        form,
        formData,
        sortOrder: item.sortOrder,
      } as FormInstance;
    });
  return nextFormInfo;
};
